import $ from 'jquery';
import { hasTouch } from '../../home24/core/touch';

(function() {
  'use strict';

  var shopTheLook = {
    init: function() {
      $('.js-shop-the-look__trigger')
        .on('mouseenter-not-touch', $.proxy(this.onTriggerMouseEnter, this))
        .on('touchend', $.proxy(this.onTriggerTouch, this));

      $('.js-shop-the-look__content').on(
        'mouseleave-not-touch',
        $.proxy(this.onMouseLeave, this)
      );

      if (hasTouch) {
        $('.js-shop-the-look__content').addClass('is-hidden');
      }
    },

    hideAll: function() {
      var that = this;

      $('.js-shop-the-look__trigger').each(function() {
        that.hide(this);
      });
    },

    onTriggerTouch: function(event) {
      var that = this;

      this.hideAll();

      setTimeout(function() {
        that.show(event.currentTarget);
      }, 500);
    },

    onTriggerMouseEnter: function(event) {
      this.show(event.currentTarget);
    },

    onMouseLeave: function(event) {
      this.hide(event.currentTarget.previousSibling);
    },

    hide: function(currentMarker) {
      var $parent = $(currentMarker).parent();

      if (hasTouch) {
        $parent.find('.js-shop-the-look__content').addClass('is-hidden');
      }
      $parent.removeClass('marker--active');
    },

    show: function(currentMarker) {
      var $parent = $(currentMarker).parent();

      if (hasTouch) {
        $parent.find('.js-shop-the-look__content').removeClass('is-hidden');
      }
      $parent.addClass('marker--active');
      $parent.find('a').addClass('hover');
    }
  };

  if ($('.js-shop-the-look').length > 0) {
    shopTheLook.init();
  }
})();



/** WEBPACK FOOTER **
 ** ./legacy/home24-desktop/layout/shopTheLook.js
 **/